<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Membership</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="membershipId">ID </label>
          <input
            id="membershipId"
            type="text"
            v-model="id"
            class="form-control"
            disabled
          />
        </div>
        <div class="col">
          <label for="programName">Membership program</label>
          <input
            id="programName"
            type="text"
            v-model="form.name"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorName,
            }"
          />
          <div v-if="isSubmit && error.errorName" class="text-error">
            {{ error.errorName.message }}
          </div>
        </div>
        <div class="col">
          <label for="membershipCode">Membership Code on CEGID</label>
          <input
            id="membershipCode"
            type="text"
            v-model="form.code"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorCode,
            }"
          />
          <div v-if="isSubmit && error.errorCode" class="text-error">
            {{ error.errorCode.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BrandDropdown
            v-model="form.brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
            :setDisable="mode === 'edit'"
            :class="{
              'input--error': isSubmit && error.errorBrand,
            }"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrand" class="text-error">
            {{ error.errorBrand.message }}
          </div>
        </div>
        <div class="col">
          <label for="level">Level</label>
          <input
            id="level"
            type="text"
            v-model="form.level"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorLevel,
            }"
          />
          <div v-if="isSubmit && error.errorLevel" class="text-error">
            {{ error.errorLevel.message }}
          </div>
        </div>
      </div>
      <div class="d-flex flex-row my-4">
        <input
          id="isActive"
          class="form-check-input mr-2"
          type="checkbox"
          v-model="form.isActive"
          :class="{
            'input--error': isSubmit && error.errorStatus,
          }"
        />
        <label class="form-check-label" for="isActive"> Active </label>
        <div v-if="isSubmit && error.errorStatus" class="text-error">
          {{ error.errorStatus.message }}
        </div>
      </div>
      <div class="row">
        <div class="col align-self-end">
          <label for="startPublishDate">Start publish date</label>
          <date-picker
            id="startPublishDate"
            v-bind="$attrs"
            v-model="form.startDate"
            format="D MMMM yyyy"
            :value="form.startDate"
            lang="en"
            @change="form.startDate = $event"
            :class="{
              'input--error': isSubmit && error.errorStartDate,
            }"
          />
          <div v-if="isSubmit && error.errorStartDate" class="text-error">
            {{ error.errorStartDate.message }}
          </div>
        </div>
        <div class="col">
          <label for="endPublishDate">End publish date</label>
          <date-picker
            id="endPublishDate"
            v-bind="$attrs"
            v-model="form.endDate"
            format="D MMMM yyyy"
            :value="form.endDate"
            lang="en"
            @change="form.endDate = $event"
            :class="{
              'input--error': isSubmit && error.errorEndDate,
            }"
          />
          <div v-if="isSubmit && error.errorEndDate" class="text-error">
            {{ error.errorEndDate.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="minimumFirstPurchase">Minimum first purchase</label>
          <NumberInput
            input-id="minimumFirstPurchase"
            v-model.number="form.minimumFirstPurchase"
            :is-decimal-allowed="true"
            :dynamic-class="{
              'input--error': isSubmit && error.errorMinimumFirstPurchase,
            }"
          />
          <div
            v-if="isSubmit && error.errorMinimumFirstPurchase"
            class="text-error"
          >
            {{ error.errorMinimumFirstPurchase.message }}
          </div>
        </div>
        <div class="col">
          <label for="minimumAccumulativePurchase"
            >Minimum cumulative purchase</label
          >
          <NumberInput
            input-id="minimumAccumulativePurchase"
            v-model.number="form.minimumAccumulativePurchase"
            :is-decimal-allowed="true"
            :dynamic-class="{
              'input--error':
              isSubmit && error.errorMinimumAccumulativePurchase,
            }"
          />
          <div
            v-if="isSubmit && error.errorMinimumAccumulativePurchase"
            class="text-error"
          >
            {{ error.errorMinimumAccumulativePurchase.message }}
          </div>
        </div>
      </div>
      <div class="voucher">
        <div class="row">
          <div class="col">
            <h3>Vouchers</h3>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label for="voucherSelected">Voucher</label>
            <multiselect
              id="voucherSelected"
              v-model="voucherSelect"
              :options="voucherOptions"
              label="name"
              track-by="id"
              @input="getDataPrivileges">
            </multiselect>
          </div>
          <div class="col">
            <div>Voucher name</div>
            <div>{{ productName }}</div>
          </div>
          <div class="col">
            <label for="quantity">Quantity</label>
            <NumberInput input-id="quantity" v-model.number="productQuantity" @input="checkQuantityValue" :is-included-input-validation="true"/>
          </div>
          <div class="col">
            <br />
            <button
              class="btn btn-outline-dark"
              style="width: 40%"
              :disabled="
                !this.voucherSelect ||
                !this.productCode ||
                !this.productQuantity
              "
              @click="checkValidateAddList()">
              Add
            </button>
          </div>
        </div>
        <ListVoucher :items="list" @deleteVoucher="deleteVoucher" />
      </div>
      <div class="d-flex justify-content-end mt-5">
        <button
          @click="() => $router.push({ name: 'Membership' })"
          class="btn btn-outline-danger btn-cancel">
          Cancel
        </button>
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && mode === 'edit'">
            <button class="btn-back" @click="bindingData()">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="mt-5">
            <button
              v-if="showSuccess"
              class="btn-back"
              @click="() => $router.push({ name: 'Membership' })">
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button v-if="!showSuccess" class="btn-back" @click="hideDialogMain">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <div class="content-dialog">
        <h3>ข้อมูล Voucher จะถูกลบทั้งหมด</h3>
        <div class="text-center">
          <button class="btn-back mr-5" @click="confirmClearListVoucher">
            ตกลง
          </button>
          <button class="btn-back" @click="cancelChangeBrand">ปิด</button>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogUpdate" width="500" persistent>
      <div class="content-dialog">
        <h3>จะทำการเปลี่ยนแปลงข้อมูลเดิมหรือไม่ ?</h3>
        <div class="text-center">
          <button class="btn-back mr-5" @click="updateDataInTable">ตกลง</button>
          <button class="btn-back" @click="dialogUpdate = false">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import MembershipService from "services/api/membership.service";
import PrivilegeService from "services/api/privilege.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import ListVoucher from "./ListVoucher.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  components: {
    NumberInput,
    BrandDropdown,
    ListVoucher,
  },
  data() {
    const mode = this.$route.query.id ? "edit" : "add";
    const id = this.$route.query.id;
    return {
      mode,
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      id,
      langSelect: { text: "TH" },
      form: {
        id: null,
        brandSelected: null,
        name: null,
        code: null,
        isActive: true,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: null,
        level: null,
        minimumFirstPurchase: null,
        minimumAccumulativePurchase: null,
      },
      error: {
        errorName: null,
        errorCode: null,
        errorBrand: null,
        errorLevel: null,
        errorStatus: null,
        errorStartDate: null,
        errorEndDate: null,
        errorMinimumFirstPurchase: null,
        errorMinimumAccumulativePurchase: null,
      },
      tempBrandSelect: null,
      isSubmit: false,
      voucherSelect: null,
      voucherOptions: [],
      productName: null,
      productCode: null,
      productCategoryName: null,
      productQuantity: null,
      isDisableAdd: false,
      list: [],
      dialogDelete: false,
      dialogUpdate: false,
      newBrandVal: null,
      oldBrandVal: null,
    };
  },
  async mounted() {
    if (this.id) {
      await this.bindingData();
    }
  },
  watch: {
    "form.brandSelected": {
      handler: function (val, oldVal) {
        this.newBrandVal = val;
        this.oldBrandVal = oldVal;
      },
      deep: true,
    },
  },
  methods: {
    async getPrivilegeList(brandCode) {
      if (
        this.mode === "edit" &&
        this.form.brandSelected === this.newBrandVal
      ) {
        return;
      }
      const param = {
        currentPage: 1,
        limit: 9999,
        brandCode: brandCode,
        status: "ACTIVE",
        privilegeType: "MEMBERSHIP",
      };
      await PrivilegeService.getListPrivileges(param)
        .then((res) => {
          const data = res.data;
          this.voucherOptions = data.privileges;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    onSubmit() {
      const form = this.form;
      this.isSubmit = true;
      this.showSuccess = false;
      const body = {
        id: form.id,
        brandCode: form.brandSelected?.id,
        name: form.name,
        code: form.code,
        status: form.isActive,
        startDate: moment(form.startDate).format("DD/MM/YYYY"),
        endDate: form.endDate
          ? moment(form.endDate).format("DD/MM/YYYY")
          : null,
        level: form.level,
        minimumFirstPurchase: form.minimumFirstPurchase,
        minimumAccumulativePurchase: form.minimumAccumulativePurchase,
        privileges: this.list.map((p) => {
          return {
            privilegeId: p.privilegeId,
            quantity: Number.parseInt(p.quantity),
          };
        }),
      };
      let query = this.$route.query;
      if (query?.id) {
        console.log(body);
        this.addOrEditMembership(body, true);
      } else {
        console.log(body);
        this.addOrEditMembership(body);
      }
    },
    async addOrEditMembership(body, isUpdate = false) {
      this.isLoading = true;
      MembershipService.createOrUpdateMembership(body, this.id, isUpdate)
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          if (data.message) {
            this.message = data.message;
            this.showDialog = true;
          }
          if (data.status === "failure") {
            this.setErrorText(data.errors);
          } else {
            this.showSuccess = true;
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    async bindingData() {
      this.isLoading = true;
      this.setDefault();
      try {
        await MembershipService.getDetailMembership(this.id)
          .then(async (res) => {
            this.isLoading = false;
            const data = await res.data.membershipTier;
            this.form = {
              id: data.id,
              brandSelected: data.brandCode,
              name: data.name,
              code: data.code,
              isActive: data.status === "Active",
              startDate: moment(data.startDate, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              ),
              endDate: data.endDate
                ? moment(data.endDate, "DD/MM/YYYY").format("YYYY-MM-DD")
                : "",
              level: data.level,
              minimumFirstPurchase: data.minimumFirstPurchase,
              minimumAccumulativePurchase: data.minimumAccumulativePurchase,
            };
            this.list = data.privileges;
            this.getPrivilegeList(data.brandCode);
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async getDataPrivileges() {
      const id = this.voucherSelect?.id;
      await PrivilegeService.getDetailPrivilege(id)
        .then((res) => {
          const data = res.data.privilege;
          this.productName = data.nameEn;
          this.productCode = data.parentCode;
          this.productCategoryName = data.categoryNameEn;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    checkValidateAddList() {
      if (!this.voucherSelect || !this.productCode || !this.productQuantity) {
        return;
      }
      this.addTolist();
    },
    addTolist() {
      const duplicate = this.list.some(
        (item) => item.privilegeId === this.voucherSelect?.id
      );
      if (duplicate) {
        this.dialogUpdate = true;
      } else {
        this.list.push({
          privilegeId: this.voucherSelect?.id,
          privilegeName: this.productName,
          productParentCode: this.productCode,
          productCategoryName: this.productCategoryName,
          quantity: this.productQuantity,
        });
      }
    },
    updateDataInTable() {
      this.list
        .filter((item) => item.privilegeId === this.voucherSelect?.id)
        .forEach((i) => (i.quantity = this.productQuantity));
      this.dialogUpdate = false;
    },
    deleteVoucher(id) {
      this.list.forEach((i, index) => {
        if (i.privilegeId === id) {
          this.list.splice(index, 1);
        }
      });
    },
    checkQuantityValue() {
      if (this.productQuantity <= 0) {
        this.productQuantity = 1;
      } else if (this.productQuantity >= 100) {
        this.productQuantity = 100;
      }
    },
    setErrorText(errors) {
      this.error.errorName = errors.find((e) => e.fieldName === "name");
      this.error.errorCode = errors.find((e) => e.fieldName === "code");
      this.error.errorBrand = errors.find((e) => e.fieldName === "brandCode");
      this.error.errorLevel = errors.find((e) => e.fieldName === "level");
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorStartDate = errors.find(
        (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorMinimumFirstPurchase = errors.find(
        (e) => e.fieldName === "minimumFirstPurchase"
      );
      this.error.errorMinimumAccumulativePurchase = errors.find(
        (e) => e.fieldName === "minimumAccumulativePurchase"
      );
    },
    setBrand(brand) {
      if (brand !== this.form.brandSelected && this.list.length > 0) {
        this.dialogDelete = true;
      }
      this.form.brandSelected = brand || "";
      if (brand) {
        this.getPrivilegeList(brand.id);
      }
    },
    hideDialogMain() {
      this.showDialog = false;
      this.bindingData(this.id);
    },
    cancelChangeBrand() {
      this.form.brandSelected = this.oldBrandVal;
      this.dialogDelete = false;
    },
    confirmClearListVoucher() {
      this.form.brandSelected = this.newBrandVal;
      this.list = [];
      this.voucherSelect = null;
      this.productName = null;
      this.productCode = null;
      this.productCategoryName = null;
      this.productQuantity = null;
      this.dialogDelete = false;
    },
    setBrands(brands) {
      const listBrands = brands;
      listBrands
        .filter((f) => f.id === this.form.brandSelected)
        .map((brand) => {
          this.form.brandSelected = brand;
        });
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}
.content-dialog {
  height: 300px;
  background: #fff;
  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }
  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
